import { Club } from "hooks/apiManagement/useClubList";
import { Teamsheet, TeamsheetPlayerData, TeamsheetPlayerSchema } from "../../types/apiManagement";

import { _ } from "i18n";

export const getTeamName = (player: TeamsheetPlayerData, homeTeam: string, awayTeam: string): string => {
    return player.data.provider.team === 'home' ? homeTeam : awayTeam;
};

export const createNonPartnerPlayerData = (
    player: TeamsheetPlayerData,
    findSimilarClubs: (teamName: string) => Club[],
    homeTeam: string,
    awayTeam: string
) => {
    const teamName = getTeamName(player, homeTeam, awayTeam);
    return {
        id: null,
        firstName: player.data.provider.formattedName.firstName,
        lastName: player.data.provider.formattedName.lastName,
        npClubName: teamName,
        nationality: player.data.provider.nationality || '',
        playedInNationalTeam: false,
        birthday: player.data.provider.birthday || '',
    }
};

export const createPartnerPlayerData = (
    player: TeamsheetPlayerData,
    teamId: number,
) => {
    return {
        id: null,
        firstName: player.data.provider.formattedName?.firstName,
        lastName: player.data.provider.formattedName?.lastName,
        checked: false,
        height: player.data.provider?.height,
        weight: player.data.provider?.weight,
        teamId,
        birthday: player.data.provider.birthday || '',
        nationality: player.data.provider.nationality || '',
        nationality2: null,
        position: '',
        position2: null,
        strongestFoot: null,
        notes: null,
        photo: null,
        tranLink: null,
        federationLink: null,
        playedInNationalTeam: false,
    };
};

export const handleOperationSuccess = (
    result: { success: boolean; message: string },
    onSuccess: (message: string) => void
) => {
    if (result.success) {
        onSuccess(result.message);
        return true;
    }
    return false;
};

export const mapTeamPlayers = (players: Teamsheet[] = [], team: string): TeamsheetPlayerData[] => 
    players.map((player, index) => {
        const parseResult = TeamsheetPlayerSchema.safeParse(player);

        const playerData = parseResult.data;
        return {
            ...playerData,
            name: `${playerData?.data.provider.formattedName.firstName} ${playerData?.data.provider.formattedName.lastName}`,
        } as TeamsheetPlayerData;
    }) as TeamsheetPlayerData[];

export const handlePlayerMapping = async (
    player: TeamsheetPlayerData | null,
    value: string,
    mapPlayer: (player: TeamsheetPlayerData, value: string) => Promise<{ success: boolean; message: string }>,
    onSuccess: (message: string) => void,
    onError: (message: string) => void,
    onComplete: () => void
) => {
    if (!player) {
        onError("tasks.modal.teamsheet.error.no_player");
        return;
    }
    const result = await mapPlayer(player, value);
    if (handleOperationSuccess(result, (message) => {
        onSuccess(message);
        onComplete();
    })) {
        return;
    }
};

export const getClubId = (teamName: string, findSimilarClubs: (teamName: string) => Club[]): number | null => {
    const similarClubs = findSimilarClubs(teamName);
    return similarClubs?.[0]?.value ?? null;
};